module.exports = __webpack_public_path__ + "img/icon_neirongcehuayunying.06fcf1d7.png";